export default "__VITE_ASSET__p5B2XESJ__"